import { getLocale } from "../runtime";

const sv_decountryenglish = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Germany`
};

const decountryenglish = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_decountryenglish(inputs)
	return "deCountryEnglish";
};

export { decountryenglish as "deCountryEnglish" };